export const cardsPanelsState = {
  expanded: [21] //Add homeLocation.SiteId
}